export default "__VITE_ASSET__3b6d138a__"